var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2sksqf6vma"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1122H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x1gte5rfyb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.548 0c.246 0 .47.14.578.36l1.366 2.766 3.053.444a.644.644 0 0 1 .357 1.099l-2.21 2.153.522 3.041a.644.644 0 0 1-.935.68L5.55 9.107l-2.731 1.436a.645.645 0 0 1-.936-.68l.522-3.04-2.21-2.154a.644.644 0 0 1 .358-1.1l3.053-.443L4.97.359A.645.645 0 0 1 5.548 0zm0 2.1L4.611 4a.645.645 0 0 1-.485.353l-2.096.304 1.516 1.479a.645.645 0 0 1 .186.57l-.358 2.088 1.875-.986a.644.644 0 0 1 .6 0l1.874.986-.358-2.088a.645.645 0 0 1 .186-.57l1.516-1.479-2.096-.304A.645.645 0 0 1 6.486 4l-.938-1.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sqfowmb2pc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0c6.056 0 11 4.943 11 11 0 6.056-4.943 11-11 11-6.056 0-11-4.943-11-11C0 4.944 4.943 0 11 0zm0 1.29c-5.355 0-9.71 4.355-9.71 9.71s4.355 9.71 9.71 9.71 9.71-4.355 9.71-9.71S16.356 1.29 11 1.29z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "faldh5oond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.422 0c4.625 0 8.422 3.797 8.422 8.422s-3.797 8.422-8.422 8.422C3.796 16.844 0 13.047 0 8.422 0 3.796 3.797 0 8.422 0zm0 1.29a7.14 7.14 0 0 0-7.133 7.132 7.14 7.14 0 0 0 7.133 7.133 7.14 7.14 0 0 0 7.133-7.133 7.14 7.14 0 0 0-7.133-7.133z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2sksqf6vma)",
    transform: "translate(-516 -305)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x1gte5rfyb)",
    transform: "translate(521.452 310.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0B70D",
    d: "M0 0h11.097v10.617H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sqfowmb2pc)",
    transform: "translate(516 305)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0B70D",
    d: "M0 0h22v22H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#faldh5oond)",
    transform: "translate(518.578 307.578)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0B70D",
    d: "M0 0h16.844v16.844H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyOrange);
export default __webpack_public_path__ + "static/media/currency_orange.218491124f57bde6d83fbf6e9f2e2313.svg";
export { ForwardRef as ReactComponent };